import { DataSource, Layout, Map, Panel, Splitter } from "@mcleod/components";
import { MobileCommLoginLogoutHistList } from "../MobileCommLoginLogoutHistList";

export abstract class AutogenLayoutMobileCommLoginLogoutHistAndMapView extends Layout {
    layoutMobileCommLoginLogoutHistList: MobileCommLoginLogoutHistList;
    loginLogoutMap: Map;
    panelMapView: Panel;
    sourceMcLoginLogoutHist: DataSource;
    splitterTracking: Splitter;
}
